import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  leftAction;
  rightAction;
  innerWidth;
  rightWidth = false;
  constructor(private route: ActivatedRoute, private location: Location, private userService: UserService) {}

  ngOnInit() {
    this.subscriptions.add(
      this.route.url.subscribe(() => {
        const routeData = this.route.snapshot.firstChild.data;
        this.leftAction = routeData.leftAction;
        this.rightAction = routeData.rightAction;
        this.innerWidth = routeData.innerWidth;
        if (routeData.rightWidth) this.rightWidth = true;
      })
    );
  }

  back(): void {
    this.location.back();
  }

  logout() {
    this.userService.logout(true);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
